import { useContext } from 'react'
import { AppContext } from '../utils/AppProvider'

const useAppContext = () => {
  return useContext(AppContext)
}

export default useAppContext
